import { MultiEntityAccount } from "@components/accounts/multiEntityAccountGrouping";
import { TransactionRuleActionFormSchema } from "../constants";

type AccountActionFormValue = NonNullable<
    TransactionRuleActionFormSchema["value"]
>;

interface BuildAccountActionValueParams {
    account: MultiEntityAccount | null;
}

export function buildCashAccountActionValue({
    account,
}: BuildAccountActionValueParams): AccountActionFormValue {
    return account
        ? {
              accountIds: account.constituents.map(
                  (constituent) => constituent.id,
              ),
          }
        : {};
}

export function buildAccrualAccountActionValue({
    account,
    autoConfirm,
}: BuildAccountActionValueParams & {
    autoConfirm: boolean | undefined;
}): AccountActionFormValue {
    return {
        ...buildCashAccountActionValue({ account }),
        autoConfirm,
    };
}
